import yup from "../utility/ValidationUtilty";

export type VideoCategorys = {
  id: string;
  title: string;
  type: "admin" | "municipality";
  createUser: string;
  createAt: Date;
  displayOrder: string;
}

export const newVideoCategorys: VideoCategorys = {
  id: "",
  title: "",
  type: "municipality",
  createUser: "",
  createAt: new Date(),
  displayOrder: ""
}

export const videoCategorysSchema = yup.object({
  title: yup.string().required(),
})